import {
  ConfirmEmailRequest,
  DeleteUserDTO,
  LoginResponse,
  LoginUserDTO,
  ResetPasswordRequest,
  UserDTO,
} from "~/types/authentication";
import { baseApi } from "./baseApi";

//Mutation should be used for anything which changes the data on the server

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginUserDTO>({
      query: (loginUser) => ({
        url: "/Auth/login",
        method: "POST",
        body: loginUser,
        credentials: "include",
      }),
      transformResponse: (response: LoginResponse, meta) => {
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        console.log("toast");
        return {
          originalArg: arg,
          error: response,
        };
      },
      invalidatesTags: ["Users"],
    }),
    revoke: builder.mutation<Response, DeleteUserDTO>({
      query: (userToRevoke) => ({
        url: "/Auth/revoke",
        method: "POST",
        body: userToRevoke,
        credentials: "include",
      }),
      transformResponse: (response: Response, meta) => {
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        return {
          originalArg: arg,
          error: response,
        };
      },
      invalidatesTags: ["Users"],
    }),
   
   
    confirmEmail: builder.mutation<any, ConfirmEmailRequest>({
      query: (confirm) => ({
        url: `/auth/confirmEmail?email=${confirm.email}&code=${confirm.code}`,
        method: "POST",
        credentials: "include",
        //Mutations require the invalidatesTags instead of providesTags
        invalidatesTags: ["Users"],
      }),
      invalidatesTags: ["Users"],

      transformResponse: (response: void, meta) => {
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        //Toast.show("unable to confirm email because " + JSON.stringify(response));

        return {
          originalArg: arg,
          error: response,
        };
      },
    }),
    register: builder.mutation<void, LoginUserDTO>({
      query: (newUser) => ({
        url: "/auth/register",
        method: "POST",
        body: newUser,
        credentials: "include",
        //Mutations require the invalidatesTags instead of providesTags
      invalidatesTags:["Users"],
        
      }),
      invalidatesTags:["Users"],
 
      transformResponse: (response: void, meta) => {
        return response;
      },
      
      transformErrorResponse: (response, meta, arg) => {
        //Toast.show("unable to create user because " + JSON.stringify(response));

        return {
          originalArg: arg,
          error: response,
        };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useRevokeMutation,
  useConfirmEmailMutation,
  useRegisterMutation
} = authApi;
